import { motion } from 'framer-motion'
import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled(motion.div)`
  ${tw`fixed left-0 bottom-0 z-30 w-full`};

  background-color: var(--color-bg);
  box-shadow: inset 0 0 0 0.5px var(--color-grey), 0 0px 10px rgb(0 0 0 / 10%);
`

export const Header = styled.div`
  ${tw`flex justify-between items-center px-4 py-1`}
  /* color: var(--color-gold-on-gold-light-wcag) !important; */
  background-color: var(--color-gold-white);
  border-top: 0.5px solid var(--color-gold-white-line);
  /* border-bottom: 0.5px solid var(--color-gold-lightest); */
`

export const Main = styled.div`
  ${tw`w-full overflow-auto`};
`

export const Products = styled.div`
  ${tw`px-4 py-2 flex space-x-4`};
`

export const Product = styled.div`
  flex-basis: 300px;
  flex-shrink: 0;
  flex-grow: 1;
`
